import React, { useEffect } from 'react';
import './../App.css';
import PageShell from '../components/layout/PageShell';
import PageHeader from '../components/layout/PageHeader';

const AboutPage = () => {
    useEffect(() => {
        document.title = 'animix - О нас';
    }, []);

    return (
        <PageShell narrow className="info-page">
            <PageHeader title="О нас" />
            <div className="ui-prose">
                <p>
                    Привет! Мы команда из людей, которые решили улучшить то, как мы смотрим аниме в России.
                    Мы разработали сайт, который предоставляет информацию о популярных аниме, а также позволяет вам смотреть их онлайн.
                </p>
                <p>Надеемся, у нас получается сделать Вашу жизнь чуточку лучше. чмок</p>
                <p>
                    Следите за нами в <a href="https://t.me/animixlib">Telegram</a>, если у вас есть вопросы или предложения.
                </p>
            </div>
        </PageShell>
    );
};

export default AboutPage;
